// mindzera-frontend/src/Login.jsx
import { useState } from 'react';
import { useAuth } from './AuthContext.jsx';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const { login } = useAuth();
  const nav       = useNavigate();

  const [form, set]   = useState({ email: '', password: '' });
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    setLoading(true);

    const email    = form.email.trim().toLowerCase();
    const password = form.password.trim();

    try {
      await login(email, password);   // AuthContext handles storage
      nav('/builder');
    } catch (e) {
      const msg = e.response?.data?.error || e.message || 'Login failed';
      setErr(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="h-screen flex items-center justify-center">
      <form onSubmit={submit} className="bg-white p-8 shadow rounded w-80">
        <h1 className="text-xl font-bold mb-6">Log in</h1>

        <input
          type="email"
          value={form.email}
          onChange={(e) => set({ ...form, email: e.target.value })}
          placeholder="Email"
          autoComplete="username"
          className="border w-full p-2 mb-3"
        />

        <input
          type="password"
          value={form.password}
          onChange={(e) => set({ ...form, password: e.target.value })}
          placeholder="Password"
          autoComplete="current-password"
          className="border w-full p-2 mb-4"
        />

        {err && <p className="text-red-600 text-sm mb-3">{err}</p>}

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-emerald-600 text-white py-2 rounded disabled:opacity-50"
        >
          {loading ? 'Logging in…' : 'Log in'}
        </button>
      </form>
    </section>
  );
}
